import context from "@/utils/context";
import * as utils from "@/utils";

const shareShare = utils.getInputValue("shareShare");
const sdkConfig = utils.getInputValue("sdkConfig");

const optionMenuString = utils.getInputValue("sdkConfig", "");

(async function() {
  // 初始化context
  await context.ready({
    wxConfig: sdkConfig
  });

  if (shareShare) {
    shareShare.title = decodeURIComponent(shareShare.title);
    shareShare.desc = decodeURIComponent(shareShare.desc);

    context.shareMessage(shareShare).then(res => {
      console.log("share message result: ", res);
    });
    context.shareTimeline(shareShare).then(res => {
      console.log("share timeline result: ", res);
    });
  }

  window.WeixinJSBridge && window.WeixinJSBridge.call(optionMenuString);
})();
